import { connect } from 'react-redux';
import * as actions from '../ApplicationDetails/redux/action';
import ValidationConfirmSettlementPopup from './ValidationConfirmSettlementPopup';

const mapDispatchToProps = {
  getLoanRequests: actions.getLoans,
};

export default connect(null, mapDispatchToProps)(ValidationConfirmSettlementPopup);
